import { productsKeyConstants, ProductsCategory } from '../../config';
import { getProducts } from '../utils/productsHelper';
import {
  calm_cover,
  calm_supplement,
  energy_cover,
  energy_supplement,
  female_exercise,
  goFactorBack,
  goFactorGallery,
  goFactorHowTo,
  goFactorSupplementFacts,
  goFactorWithIngredients,
  goFactorYoga,
  goFactorYogoHowTo,
  goFactorStudyLate,
  pill_inhand,
  quick_cover,
  quick_showcase,
  quick_supplement,
  reliefFactorBack,
  reliefFactorGallery,
  reliefFactorPills,
  reliefFactorProduct,
  reliefFactorWithIngredients,
  reliefFactorSupplement,
  thinkFactorBottle,
  thinkFactorSupplementFacts,
  thinkFactorStudying,
  thinkFactorBooks,
  thinkFactorDesk,
  thinkFactorDeskBook,
  sleep_cover,
  sleep_supplement,
  takingReliefFactor,
  zFactorBack,
  zFactorCabinet,
  zFactorGallery,
  zFactorNightstand,
  zFactorReading,
  zFactorSupplement,
  zFactorSupplementFacts,
  zFactorWithIngredients,
  zenFactorBack,
  zenFactorGallery,
  zenFactorSupplementFacts,
  zenFactorWithIngredients,
  zenProduct,
  zenState,
  acbBottle,
  acbBottleBack,
  acbSupplementFacts,
  antioxidantSupplement,
  fullSpectrumBottle,
  fullSpectrumBottleBack,
  fullSpectrumSupplementFacts,
  fullSpectrumSupplement,
  immuneFactorCta,
  immuneFactorBottle,
  immuneFactorBottleBack,
  immuneFactorSuppelementFacts,
  nAcetyleCystineBottle,
  nAcetyleCystineBottleBack,
  nAcetyleCystineSupplementFacts,
  nacSupplement,
  BerberineBottle,
  BerberineBottleBack,
  BerberineSupplementFacts,
  BerberineSupplement,
  vitaminBComplexBottle,
  vitaminBComplexBottleBack,
  vitaminBComplexSupplementFacts,
  redYeastRice,
  redYeastRiceBottle,
  redYeastRiceBottleBack,
  redYeastRiceSupplementFacts,
  vesselProtectionBottle,
  vesselProtectionBottleBack,
  vesselProtectionSupplementFacts,
  vesselProtection,
  vitaminBComplex,
  vitaminD3K22000Bottle,
  vitaminD3K22000BottleBack,
  vitaminD3K22000SupplementFacts,
  vitaminD3K25000Bottle,
  vitaminD3K25000BottleBack,
  vitaminD3K25000SupplementFacts,
  vitaminD3K22000Supplement,
  vitaminD3K25000Supplement,
} from '../../src/assets/images/pdp';
const products = getProducts();
export const PRODUCT_OFFERS = {
  [ProductsCategory.RELIEF_FACTOR]: [
    {
      labelTitle: 'Best Deal',
      saveOffer: '• Save 35%',
      radioButtonTitle: 'Autoship, First Month Only',
      radioButtonValue: productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC,
      showShippingHandling: true,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC]
          .isEligibleForSingleOrder,
      multiPoints: [
        {
          title: 'Relief Factor (60 Packets)',
          points: [
            `Save $65 in month one and pay only $${Number(
              products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC]
                .recurringPrice
            ).toFixed(2)} monthly <span class="noWarp"> after that </span>`,
            'Select a <b>Free Gift</b> to receive with each ongoing order',
            'Set your schedule based on your needs',
            'No fees, no commitments - skip, change, cancel anytime',
          ],
          alternateTitle: 'Relief Factor (60 Packets)',
        },
        /* {
          title: '3-Week QuickStart',
          points: [
            'Save 78% on your first shipment',
            'Feel Better or Your <span class="noWarp">Money Back ***</span>',
            'Second shipment sent in 3 weeks',
          ],
        },
        {
          title: 'Plus Ongoing Autoship & Save',
          points: [
            '15% ongoing savings! <s>Single order $93.95</s><span class="noWarp"> Now only $79.95</span>',
            'Easy, no-questions-asked cancellation',
            "Relax knowing you won't run out",
          ],
        }, */
      ],
      points: [],

      initialPrice: Number(
        products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC].recurringPrice
      ).toFixed(2),

      // initialPrice: Number(
      //   products[productsKeyConstants.RF_FULL_SPECTRUM_E].initialPrice
      // ),
      // orginalPrice: Number(
      //   products[productsKeyConstants.RF_FULL_SPECTRUM_E].single_price
      // ),
      // discountPrice: Number(
      //   products[productsKeyConstants.RF_RELIEF_FACTOR_QS].initialPrice
      // ),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Single Purchase',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC_SINGLE,
      showShippingHandling: true,
      points: [
        'Relief Factor — 60 packets',
        'One to two months supply depending on usage',
      ],
      orginalPrice: Number(
        products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC].single_price
      ).toFixed(2),
      // discountPrice: 84.95,
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.ZEN_FACTOR]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_ZEN_FACTOR,
      showShippingHandling: false,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_ZEN_FACTOR].isEligibleForSingleOrder,
      points: [
        // 'Feel Better or Your <span class="noWarp">Money Back ***</span>',
        'Zen Factor 60-count bottle',
        'Save 24% on first order',
        `Automatically renews at $${Number(
          products[productsKeyConstants.RF_ZEN_FACTOR].recurringPrice
        ).toFixed(2)}/mo until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_ZEN_FACTOR].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_ZEN_FACTOR].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_ZEN_FACTOR].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_ZEN_FACTOR_SINGLE,
      showShippingHandling: false,
      points: ['Zen Factor 60-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_ZEN_FACTOR].single_price
      ).toFixed(2),
      // discountPrice: 84.95,
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.GO_FACTOR]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_GO_FACTOR,
      showShippingHandling: false,

      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_GO_FACTOR].isEligibleForSingleOrder,
      points: [
        // 'Feel Better or Your <span class="noWarp">Money Back ***</span>',
        'Go Factor 60-count bottle',
        'Save 14% on first order',
        `Automatically renews at $${Number(
          products[productsKeyConstants.RF_GO_FACTOR].recurringPrice
        ).toFixed(2)}/mo until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_GO_FACTOR].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_GO_FACTOR].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_GO_FACTOR].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_GO_FACTOR_SINGLE,
      showShippingHandling: false,
      points: ['Go Factor 60-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_GO_FACTOR].single_price
      ).toFixed(2),
      // discountPrice: 84.95,
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.Z_FACTOR]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_Z_FACTOR,
      showShippingHandling: false,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_Z_FACTOR].isEligibleForSingleOrder,
      points: [
        // 'Feel Better or Your <span class="noWarp">Money Back ***</span>',
        'Z Factor 60-count bottle',
        'Save 33% on first order',
        `Automatically renews at $${Number(
          products[productsKeyConstants.RF_Z_FACTOR].recurringPrice
        ).toFixed(2)}/mo until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_Z_FACTOR].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_Z_FACTOR].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_Z_FACTOR].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_Z_FACTOR_SINGLE,
      showShippingHandling: false,
      points: ['Z Factor 60-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_Z_FACTOR].single_price
      ).toFixed(2),
      // discountPrice: 84.95,
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.THINK_FACTOR]: [
    {
      labelTitle: 'Best Deal',
      // saveOffer: '• Save 35%',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_THINK_FACTOR,
      showShippingHandling: true,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_THINK_FACTOR].isEligibleForSingleOrder,
      points: [
        'Think Factor 60-count bottle',
        'Save 15% on all orders',
        `Automatically renews at $${Number(
          products[productsKeyConstants.RF_THINK_FACTOR].recurringPrice
        ).toFixed(2)}/mo until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_THINK_FACTOR].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_THINK_FACTOR].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_THINK_FACTOR].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_THINK_FACTOR_SINGLE,
      showShippingHandling: true,
      points: ['Think factor 60-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_THINK_FACTOR].single_price
      ).toFixed(2),
      // discountPrice: 84.95,
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.ANTIOXIDANTS]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.DE_ANTIOXIDANTS,
      isEligibleForSingleOrder:
        products[productsKeyConstants.DE_ANTIOXIDANTS].isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'Antioxidants with Vitamin C & Bioflavonoids 120-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.DE_ANTIOXIDANTS].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.DE_ANTIOXIDANTS].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.DE_ANTIOXIDANTS].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.DE_ANTIOXIDANTS].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.DE_ANTIOXIDANTS_SINGLE,
      showShippingHandling: false,
      points: ['Antioxidants with Vitamin C & Bioflavonoids 120-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.DE_ANTIOXIDANTS].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.FULL_SPECTRUM_E]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_FULL_SPECTRUM_E,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_FULL_SPECTRUM_E]
          .isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'Full Spectrum E 120-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.RF_FULL_SPECTRUM_E].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_FULL_SPECTRUM_E].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_FULL_SPECTRUM_E].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_FULL_SPECTRUM_E].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_FULL_SPECTRUM_E_SINGLE,
      showShippingHandling: false,
      points: ['Full Spectrum E 120-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_FULL_SPECTRUM_E].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.IMMUNE_FACTOR]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_IMMUNE_FACTOR,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_IMMUNE_FACTOR]
          .isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'Immune Factor 120-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.RF_IMMUNE_FACTOR].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_IMMUNE_FACTOR].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_IMMUNE_FACTOR].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_IMMUNE_FACTOR].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_IMMUNE_FACTOR_SINGLE,
      showShippingHandling: false,
      points: ['Immune Factor 120-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_IMMUNE_FACTOR].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.N_ACETYL_CYSTEINE]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_N_ACETYL_CYSTEINE,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_N_ACETYL_CYSTEINE]
          .isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'NAC 120-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.RF_N_ACETYL_CYSTEINE].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_N_ACETYL_CYSTEINE].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_N_ACETYL_CYSTEINE].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_N_ACETYL_CYSTEINE].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_N_ACETYL_CYSTEINE_SINGLE,
      showShippingHandling: false,
      points: ['NAC 120-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_N_ACETYL_CYSTEINE].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.BERBERINE]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_BERBERINE,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_BERBERINE].isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'Berberine 60-count bottle',
        'Save 15% on all orders',
        `Automatically renews at $${Number(
          products[productsKeyConstants.RF_BERBERINE].recurringPrice
        ).toFixed(2)}/mo until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_BERBERINE].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_BERBERINE].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_BERBERINE].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_BERBERINE_SINGLE,
      showShippingHandling: false,
      points: ['Berberine 60-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_BERBERINE].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.RED_YEAST_RICE]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_RED_YEAST_RICE,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_RED_YEAST_RICE]
          .isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'Red Yeast Rice with CoQ10 120-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.RF_RED_YEAST_RICE].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_RED_YEAST_RICE].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_RED_YEAST_RICE].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_RED_YEAST_RICE].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_RED_YEAST_RICE_SINGLE,
      showShippingHandling: false,
      points: ['Red Yeast Rice with CoQ10 120-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_RED_YEAST_RICE].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.VESSEL_PROTECTION]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_VESSEL_PROTECTION,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_VESSEL_PROTECTION]
          .isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'Vessel Protection 60-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.RF_VESSEL_PROTECTION].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_VESSEL_PROTECTION].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_VESSEL_PROTECTION].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_VESSEL_PROTECTION].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_VESSEL_PROTECTION_SINGLE,
      showShippingHandling: false,
      points: ['Vessel Protection 60-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_VESSEL_PROTECTION].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.VITAMIN_B_COMPLEX]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_VITAMIN_B_COMPLEX,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_VITAMIN_B_COMPLEX]
          .isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'B-Complex 120-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.RF_VITAMIN_B_COMPLEX].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_B_COMPLEX].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_B_COMPLEX].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_B_COMPLEX].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_VITAMIN_B_COMPLEX_SINGLE,
      showShippingHandling: false,
      points: ['Vitamin B Complex 120-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_B_COMPLEX].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.VITAMIN_D_K2]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_VITAMIN_D_K2,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_VITAMIN_D_K2].isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'Vitamin D3 and K-2 2000 IU 120-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.RF_VITAMIN_D_K2].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_D_K2].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_D_K2].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_D_K2].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_VITAMIN_D_K2_SINGLE,
      showShippingHandling: false,
      points: ['Vitamin D3 and K-2 2000 IU 120-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_D_K2].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
  [ProductsCategory.VITAMIN_D_K5]: [
    {
      labelTitle: 'Best Deal',
      radioButtonTitle: 'Autoship & Save',
      radioButtonValue: productsKeyConstants.RF_VITAMIN_D_K5,
      isEligibleForSingleOrder:
        products[productsKeyConstants.RF_VITAMIN_D_K5].isEligibleForSingleOrder,
      showShippingHandling: false,
      points: [
        'Vitamin D3 and K-2 5000 IU 120-count bottle',
        'Save 15% on all orders',
        `Automatically renews every 2 months at $${Number(
          products[productsKeyConstants.RF_VITAMIN_D_K5].recurringPrice
        ).toFixed(2)} until canceled`,
      ],
      initialPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_D_K5].initialPrice
      ).toFixed(2),
      orginalPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_D_K5].single_price
      ).toFixed(2),
      discountPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_D_K5].recurringPrice
      ).toFixed(2),
      labelBgColor: '#9CD4EA',
    },
    {
      labelTitle: 'Buy Once',
      radioButtonTitle: 'Buy Once',
      radioButtonValue: productsKeyConstants.RF_VITAMIN_D_K5_SINGLE,
      showShippingHandling: false,
      points: ['Vitamin D3 and K-2 5000 IU 120-count bottle'],
      orginalPrice: Number(
        products[productsKeyConstants.RF_VITAMIN_D_K5].single_price
      ).toFixed(2),
      labelBgColor: '#DCEEF6',
    },
  ],
};

export const IMAGE_LIST_INVENTORY = {
  [ProductsCategory.RELIEF_FACTOR]: [
    {
      id: 6,
      img: reliefFactorWithIngredients,
      type: 'withingredients',
    },
    {
      id: 1,
      img: reliefFactorGallery,
      type: 'showcase',
    },
    // {
    //   id: 2,
    //   img: reliefFactorBack,
    //   type: 'other',
    // },
    {
      id: 3,
      img: reliefFactorProduct,
      type: 'cover',
    },
    {
      id: 4,
      img: reliefFactorPills,
      type: 'video',
    },
    {
      id: 5,
      img: reliefFactorSupplement,
      type: 'supplement',
    },
  ],
  [ProductsCategory.THINK_FACTOR]: [
    {
      id: 6,
      img: thinkFactorDeskBook,
      type: 'other',
    },
    {
      id: 6,
      img: thinkFactorBottle,
      type: 'other',
    },
    {
      id: 2,
      img: thinkFactorStudying,
      type: 'other',
    },
    {
      id: 3,
      img: thinkFactorDesk,
      type: 'other',
    },
    {
      id: 4,
      img: thinkFactorBooks,
      type: 'other',
    },
    {
      id: 1,
      img: thinkFactorSupplementFacts,
      type: 'other',
    },
  ],

  [ProductsCategory.ZEN_FACTOR]: [
    {
      id: 11,
      img: zenFactorWithIngredients,
      type: 'other',
    },
    {
      id: 10,
      img: zenState,
      type: 'other',
    },
    {
      id: 7,
      img: zenFactorGallery,
      type: 'cover',
    },
    {
      id: 8,
      img: zenFactorBack,
      type: 'other',
    },
    {
      id: 9,
      img: zenProduct,
      type: 'video',
    },

    {
      id: 12,
      img: zenFactorSupplementFacts,
      type: 'supplement',
    },
  ],

  [ProductsCategory.GO_FACTOR]: [
    {
      id: 18,
      img: goFactorWithIngredients,
      type: 'other',
    },
    {
      id: 28,
      img: goFactorStudyLate,
      type: 'other',
    },
    {
      id: 13,
      img: goFactorGallery,
      type: 'cover',
    },
    {
      id: 14,
      img: goFactorBack,
      type: 'other',
    },
    {
      id: 15,
      img: goFactorYoga,
      type: 'video',
    },
    // {
    //   id: 16,
    //   img: goFactorHowTo,
    //   type: 'other',
    // },
    {
      id: 17,
      img: goFactorYogoHowTo,
      type: 'other',
    },
    {
      id: 19,
      img: goFactorSupplementFacts,
      type: 'supplement',
    },
  ],

  [ProductsCategory.Z_FACTOR]: [
    {
      id: 26,
      img: zFactorWithIngredients,
      type: 'other',
    },
    {
      id: 24,
      img: zFactorNightstand,
      type: 'other',
    },
    {
      id: 20,
      img: zFactorGallery,
      type: 'cover',
    },
    {
      id: 21,
      img: zFactorBack,
      type: 'other',
    },
    {
      id: 22,
      img: zFactorCabinet,
      type: 'video',
    },
    // {
    //   id: 23,
    //   img: zFactorSupplement,
    //   type: 'other',
    // },
    {
      id: 25,
      img: zFactorReading,
      type: 'other',
    },
    {
      id: 27,
      img: zFactorSupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.ANTIOXIDANTS]: [
    {
      id: 29,
      img: antioxidantSupplement,
      type: 'other',
    },
    {
      id: 29,
      img: acbBottle,
      type: 'other',
    },
    {
      id: 49,
      img: acbBottleBack,
      type: 'other',
    },
    {
      id: 30,
      img: acbSupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.FULL_SPECTRUM_E]: [
    {
      id: 31,
      img: fullSpectrumSupplement,
      type: 'other',
    },
    {
      id: 31,
      img: fullSpectrumBottle,
      type: 'other',
    },
    {
      id: 50,
      img: fullSpectrumBottleBack,
      type: 'other',
    },
    {
      id: 32,
      img: fullSpectrumSupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.IMMUNE_FACTOR]: [
    {
      id: 59,
      img: immuneFactorCta,
      type: 'other',
    },
    {
      id: 33,
      img: immuneFactorBottle,
      type: 'other',
    },
    {
      id: 52,
      img: immuneFactorBottleBack,
      type: 'other',
    },
    {
      id: 34,
      img: immuneFactorSuppelementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.N_ACETYL_CYSTEINE]: [
    {
      id: 60,
      img: nacSupplement,
      type: 'other',
    },
    {
      id: 35,
      img: nAcetyleCystineBottle,
      type: 'other',
    },
    {
      id: 52,
      img: nAcetyleCystineBottleBack,
      type: 'other',
    },
    {
      id: 36,
      img: nAcetyleCystineSupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.BERBERINE]: [
    {
      id: 36,
      img: BerberineSupplement,
      type: 'other',
    },
    {
      id: 37,
      img: BerberineBottle,
      type: 'other',
    },
    {
      id: 54,
      img: BerberineBottleBack,
      type: 'other',
    },
    {
      id: 38,
      img: BerberineSupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.RED_YEAST_RICE]: [
    {
      id: 88,
      img: redYeastRice,
      type: 'other',
    },
    {
      id: 39,
      img: redYeastRiceBottle,
      type: 'other',
    },
    {
      id: 55,
      img: redYeastRiceBottleBack,
      type: 'other',
    },
    {
      id: 40,
      img: redYeastRiceSupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.VESSEL_PROTECTION]: [
    {
      id: 41,
      img: vesselProtection,
      type: 'other',
    },
    {
      id: 41,
      img: vesselProtectionBottle,
      type: 'other',
    },
    {
      id: 56,
      img: vesselProtectionBottleBack,
      type: 'other',
    },
    {
      id: 42,
      img: vesselProtectionSupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.VITAMIN_B_COMPLEX]: [
    {
      id: 43,
      img: vitaminBComplex,
      type: 'other',
    },
    {
      id: 43,
      img: vitaminBComplexBottle,
      type: 'other',
    },
    {
      id: 57,
      img: vitaminBComplexBottleBack,
      type: 'other',
    },
    {
      id: 44,
      img: vitaminBComplexSupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.VITAMIN_D_K2]: [
    {
      id: 45,
      img: vitaminD3K22000Supplement,
      type: 'other',
    },
    {
      id: 45,
      img: vitaminD3K22000Bottle,
      type: 'other',
    },
    {
      id: 57,
      img: vitaminD3K22000BottleBack,
      type: 'other',
    },
    {
      id: 46,
      img: vitaminD3K22000SupplementFacts,
      type: 'supplement',
    },
  ],
  [ProductsCategory.VITAMIN_D_K5]: [
    {
      id: 47,
      img: vitaminD3K25000Supplement,
      type: 'other',
    },
    {
      id: 47,
      img: vitaminD3K25000Bottle,
      type: 'other',
    },
    {
      id: 59,
      img: vitaminD3K25000BottleBack,
      type: 'other',
    },
    {
      id: 48,
      img: vitaminD3K25000SupplementFacts,
      type: 'supplement',
    },
  ],
};

export const PRODUCT_DETAILS_INVENTORY = {
  [ProductsCategory.RELIEF_FACTOR]: {
    prodCategory: 'Pain Relief',
    totalRatings: 56,
    reviewsCount: 5,
    prodTitle: 'Relief Factor',
    subTitle:
      // "Created to support your body's ability to reduce or even <span class=noWarp>eliminate pain.</span>",
      'Reduce or even eliminate pain. Try our <span class="noWarp">3-Week QuickStart.</span>',
    /* prodDesc:
      'Relief Factor was meticulously formulated by doctors to continuously reduce or even eliminate joint and muscle pain, including back, neck, shoulders, hips, and knees, as well as general muscle aches and pains. Relief Factor contains 60 convenient packets.', */
    directionDesc:
      'Take 1 packet three times daily. Once you notice improvement, try reducing to 2 or even 1 packet a day, or as directed by your physician.*',
  },
  [ProductsCategory.THINK_FACTOR]: {
    prodCategory: '',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Think Factor',
    subTitle: 'Think Clearer. Perform Better. Daily.',
    prodDesc:
      'Unlock mental clarity and precision. Stay sharp, nurture your memory, and boost your attention with Think Factor—where brain power and performance meet for lasting, daily performance!',
    directionDesc:
      'Take 1 capsule twice daily or as recommended by your physician.',
  },
  [ProductsCategory.ZEN_FACTOR]: {
    prodCategory: 'Anxiety Relief',
    totalRatings: 56,
    reviewsCount: 5,
    prodTitle: 'Zen Factor',
    subTitle: "Created to help support your body's stress response",
    prodDesc:
      "Zen Factor, an anti-anxiety supplement, helps your body effectively deal with stress by managing your body's level of cortisol - a hormone produced during stress - and by supporting your body's healthy nervous system function.",
    directionDesc:
      'Take one (1) capsule twice a day, or as recommended by your physician.',
  },

  [ProductsCategory.GO_FACTOR]: {
    prodCategory: 'Energy Boost',
    totalRatings: 56,
    reviewsCount: 5,
    prodTitle: 'Go Factor',
    subTitle: 'Created to give you smooth consistent energy',
    prodDesc:
      'Go Factor helps you keep going, and helps your body make better use of your caloric intake, keeping you sharp and in the game. Because it’s a supplement, you know exactly how much caffeine and taurine you’re getting, so you’re in control.',
    directionDesc:
      'For increased energy, adults can take 1 to 3 capsules, or as recommended by your physician.* Adjust the dose to suit your personal needs and tolerance, not exceeding 3 capsules.',
  },

  [ProductsCategory.Z_FACTOR]: {
    prodCategory: 'Sleep Help',
    totalRatings: 56,
    reviewsCount: 5,
    prodTitle: 'Z Factor',
    subTitle: 'Created to help you fall asleep quickly and sleep soundly.',
    prodDesc:
      "Z Factor works with your body's own systems to address multiple causes of disrupted sleep. Promotes relaxed, uninterrupted, restful sleep.",
    directionDesc:
      'Take one (1) to two (2) capsules 30 minutes before bedtime, or as recommended by your physician.',
  },
  [ProductsCategory.ANTIOXIDANTS]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Antioxidants with Vitamin C & Bioflavonoids',
    subTitle: 'Ready to Strengthen Your Health?',
    prodDesc:
      'Buy Antioxidants with Vitamin C and Bioflavonoids today and take charge of your well-being  by protecting your cells from everyday stress, supporting healthy aging, and boosting your immune response!',
    directionDesc:
      'Take 1 capsule twice daily or as recommended by your physician.',
  },
  [ProductsCategory.FULL_SPECTRUM_E]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Full Spectrum E',
    subTitle: 'Ready to Experience Full Spectrum E?',
    prodDesc:
      'Elevate your daily routine with Full Spectrum E—your next step toward a more vibrant, energized life. Your health deserves more than a one-dimensional formula. With Full Spectrum E, you get a synergy of researched nutrients that work together for optimal absorption and results.',
    directionDesc:
      'Take 1 capsule twice daily or as directed by your physician.',
  },
  [ProductsCategory.IMMUNE_FACTOR]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Immune Factors',
    subTitle: 'Ready to Strengthen Your Defenses?',
    prodDesc:
      'Fortify your body’s natural defense system with the daily, targeted formula designed to support your immune function so you can stay focused on what you love most. Give your body the targeted support it deserves.',
    directionDesc:
      'Take 1 capsule twice daily or as directed by your physician.',
  },
  [ProductsCategory.N_ACETYL_CYSTEINE]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'NAC N-Acetyl L-Cysteine',
    subTitle: 'Ready to Experience the Difference?',
    prodDesc:
      'Take control of your daily wellness—no more guesswork, no more compromise. You can feel more energized, balanced, and ready for anything by supporting your body’s production of key antioxidants, helping you tackle challenges head-on so you can feel more energized, balanced, and ready for anything.',
    directionDesc:
      'Take 1 capsule twice daily or as directed by your physician.',
  },
  [ProductsCategory.BERBERINE]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Berberine',
    subTitle: 'Ready to Support Your Health?',
    prodDesc:
      'Buy Berberine today and help your body regulate blood sugar, support metabolism, and reduce energy crashes and carb cravings. A powerful, natural option that works to balance your health and well-being!',
    directionDesc:
      'Take 1 capsule twice daily or as directed by your physician.',
  },
  [ProductsCategory.RED_YEAST_RICE]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Red Yeast Rice with CoQ10',
    subTitle: 'Help Support Your Heart',
    prodDesc:
      'Begin your journey toward a healthier heart and a more energetic life. Every capsule is crafted with care, so you can feel confident in your choice. Red Yeast Rice with CoQ10 can help your body achieve healthy cholesterol levels within the normal range. If you value your heart health, this synergy can be a perfect match.',
    directionDesc:
      'Take 1 capsule twice daily or as directed by your physician.',
  },
  [ProductsCategory.VESSEL_PROTECTION]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Vessel Protection',
    subTitle: 'Help Support Your Heart',
    prodDesc:
      'Give your cardiovascular system the attention it deserves to maintain a healthy heart and overall wellness. B vitamins are foundational for energy metabolism. If you’ve been feeling run down, can help restore your get-up-and-go. Experience the comfort of knowing you’re fueling your body with advanced B vitamins—without the premium price tag.',
    directionDesc: 'Take 1 capsule daily or as recommended by your physician.',
  },
  [ProductsCategory.VITAMIN_B_COMPLEX]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Vitamin B Complex',
    subTitle: 'Ready for Whole-Body Vitality?',
    prodDesc:
      'Take the next step toward better energy, clearer thinking, and everyday well-being and experience the revitalizing power of Vitamin B Complex for yourself! With our robust lineup of B vitamins—plus complementary nutrients like Vitamin C you can support healthy energy production, mental focus, and more!',
    directionDesc:
      'Take 1 capsule twice daily or as directed by your physician.',
  },
  [ProductsCategory.VITAMIN_D_K2]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Vitamin D3 and K-2 2000 IU',
    subTitle: 'Ready to Feel the D3 & K2 Difference?',
    prodDesc:
      'Start enjoying the benefits of better calcium absorption, distribution, and overall well-being and stop feeling tired of feeling run-down—or worried you’re not giving your bones and heart the nutrients they need. With Vitamin D3 & K2 you’ll help your body live each day to the fullest.',
    directionDesc: 'Take 1 capsule daily or as recommended by your physician.',
  },
  [ProductsCategory.VITAMIN_D_K5]: {
    prodCategory: 'Daily Essentials',
    totalRatings: '',
    reviewsCount: '',
    prodTitle: 'Vitamin D3 and K-2 5000 IU',
    subTitle: 'Ready to Feel the D3 & K2 Difference?',
    prodDesc:
      'Start enjoying the benefits of better calcium absorption, distribution, and overall well-being and stop feeling tired of feeling run-down—or worried you’re not giving your bones and heart the nutrients they need. With Vitamin D3 & K2 you’ll help your body live each day to the fullest.',
    directionDesc: 'Take 1 capsule daily or as recommended by your physician.',
  },
};
